import { Avatar, Form } from 'antd';
import INTERNAL_LINKS from '../../../enums/InternalLinks';
import LaborContractorsList from '../../../pages/LaborContractors/List/index';

import { CustomButton } from '../../../components';
import { Card, Typography, Row, Col, Input, Space } from 'antd';
import { Link } from 'react-router-dom';
import { PlusOutlined, ToolOutlined } from '@ant-design/icons';
import { removeExcelIllegalChars } from '../../../utils/helpers/helpers';
const { Title, Paragraph } = Typography;

const NaturalPersonFormExperienceSection = ({
  readOnly = false,
  personID,
  divRef,
  loading,
}) => {
  return (
    <Card
      size={'small'}
      bordered={false}
      title={
        <Title level={3}>
          <Avatar
            size={32}
            icon={<ToolOutlined />}
            style={{ backgroundColor: '#20b2aa', color: 'white' }}
            shape="square"
          />{' '}
          Experiencia laboral general
        </Title>
      }
    >
      <Row gutter={12} ref={divRef}>
        <Col span={24}>
          <Paragraph>
            Por favor realice una descripción de su experiencia laboral,
            incluyendo principalmente las palabras clave que resuman mejor los
            cargos, especialidades y áreas en las que se ha desempeñado
          </Paragraph>
          <Form.Item
            name="experiencia_laboral_general"
            rules={[
              {
                required: false,
              },
            ]}
            normalize={removeExcelIllegalChars}
          >
            <Input.TextArea
              placeholder={'Experiencia laboral general'}
              maxLength={1000}
              showCount
              rows={5}
              disabled={readOnly}
            />
          </Form.Item>
        </Col>
      </Row>
      {readOnly ? (
        <Paragraph style={{ marginTop: 10 }}>
          Recuerde que solo encuentra la información relacionada con el quehacer
          de Corpoeducación
        </Paragraph>
      ) : (
        <>
          <Space direction={'vertical'}>
            <CustomButton
              loading={loading}
              htmlType="submit"
              text="Guardar experiencia laboral general"
            />
            <Paragraph>
              Recuerde que solo debe agregar la información relacionada con el
              quehacer de Corpoeducación, de lo contrario dicha información
              puede ser eliminada de la plataforma
            </Paragraph>
          </Space>
          <CustomButton
            type={'default'}
            className={'ant-btn-info'}
            htmlType="button"
            text={
              <Link to={`${INTERNAL_LINKS.LABOR_CONTRACTORS}/${personID}`}>
                <PlusOutlined /> Agregar experiencia laboral
              </Link>
            }
          />
        </>
      )}

      <LaborContractorsList idTercero={personID} readOnly={readOnly} />
    </Card>
  );
};

export default NaturalPersonFormExperienceSection;
